export default __webpack_public_path__ + "static/media/Thumb_Accessories_06.0749f3de.png";